module.exports = __webpack_public_path__ + "static/media/tabelaPesos.f4105d52.png";